import React, { createContext, useState, useContext } from 'react';

const DesignContext = createContext();

export const useDesign = () => useContext(DesignContext);

export const DesignProvider = ({ children }) => {
  const [selectedDesign, setSelectedDesign] = useState(null);

  return (
    <DesignContext.Provider value={{ selectedDesign, setSelectedDesign }}>
      {children}
    </DesignContext.Provider>
  );
};